import { render, staticRenderFns } from "./FareClassTooltipDetail.vue?vue&type=template&id=34cc90e8&"
import script from "./FareClassTooltipDetail.vue?vue&type=script&lang=js&"
export * from "./FareClassTooltipDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports